export default function Hero() {
  return (
    <section
      id="home"
      className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20Italian%20living%20room%20with%20a%20beautiful%20burning%20pellet%20stove%2C%20bright%20orange%20and%20amber%20flames%20glowing%20warmly%2C%20cozy%20home%20interior%20with%20wooden%20furniture%20and%20stone%20wall%2C%20warm%20golden%20evening%20light%20filling%20the%20room%2C%20comfortable%20sofa%20in%20background%2C%20photorealistic%20high%20quality%20architectural%20interior%20photography%2C%20rich%20warm%20tones%20of%20amber%20and%20terracotta&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="Stufa a pellet accesa in un ambiente domestico caldo e accogliente"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 md:px-8 max-w-5xl mx-auto">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-orange-500/90 text-white text-xs font-bold px-4 py-2 rounded-full mb-6 uppercase tracking-widest">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-time-fill text-sm"></i>
          </div>
          Servizio 24 ore su 24 &mdash; Sempre disponibili
        </div>

        {/* Title */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-5">
          Esperti in Stufe a Pellet<br />
          <span className="text-orange-400">a Ravenna</span>
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          Installazione professionale, manutenzione certificata e assistenza tecnica immediata.
          Il calore giusto per la tua casa, ogni giorno dell&apos;anno.
        </p>

        {/* CTA Buttons */}
        <div className="flex items-center justify-center">
          <a
            href="tel:+393806328251"
            className="flex items-center gap-3 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base px-10 py-4 rounded-full transition-all hover:scale-105 cursor-pointer whitespace-nowrap justify-center"
          >
            <div className="w-6 h-6 flex items-center justify-center bg-orange-700 rounded-full">
              <i className="ri-phone-fill text-sm"></i>
            </div>
            Chiama Ora
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </div>
          </a>
        </div>

        {/* Stats Row */}
        <div className="mt-14 flex flex-wrap justify-center gap-6 md:gap-12">
          {[
            { value: '500+', label: 'Installazioni' },
            { value: '15+', label: 'Anni esperienza' },
            { value: '4.5★', label: 'Valutazione' },
            { value: '24/7', label: 'Assistenza' },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <p className="text-2xl md:text-3xl font-extrabold text-orange-400">{s.value}</p>
              <p className="text-xs text-white/70 uppercase tracking-wider mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center text-white/60">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </div>
      </div>
    </section>
  );
}
